
import { Component, Vue } from 'vue-property-decorator';
import {
  promotionUnsubscribeApi,
  getNewsTypeWithUnsubscribeApi
} from '@/api/api';
@Component({
  name: 'email',
})
export default class extends Vue {
  created(){
    this.getType();
  }
  public showTips:boolean=false;
  public tips:string='';
  public content:string='';

  public  getType(){
    this.getTypeList();
  }
  public async getTypeList(){
    const {data}:any=await getNewsTypeWithUnsubscribeApi();
    if(data.code==='1003'&&data.datas&&data.datas.length){
      const type:any=+this.$route.query.type;
      let flag=false;
      for(const item of data.datas){
        if(item.type===type){
          this.content=item.content;
          this.tips=item.tips;
          flag=true;
        }
      }
      if(!flag){
        this.tips='暂无退订信息';
        this.showTips=true;
      }
    }
  }
  public async out(){
    const email:any=this.$route.query.email;
    const type:any=this.$route.query.type;
    if(!email){
      this.$message.info('缺少邮箱地址');
      return
    }
    this.$confirm(
      '是否确认取消订阅',
      '',
    {
      confirmButtonText: '确认',
      cancelButtonText: '取消',
      type: 'warning',
      customClass:'emailConfirm',
    })
    .then(async () => {
      try{
        const {data}:any=await promotionUnsubscribeApi(email,type);
        if(data.code==='1003'){
          this.showTips=true;
          this.$message.success('退订成功');
        }else{
          this.$message.error('退订失败');
        }
      }catch(err){
        this.$message.error('退订失败');
      }
    }).catch(()=>{
      this.$message.info('已取消');
    });
    
  }
}
